<template>
  <div>
    <h1>Gift House Page</h1>
    <p>Content for Gift House.</p>
  </div>
</template>

<script>
export default {
  name: 'GiftHouse'
}
</script>

<style>
/* 添加样式 */
</style>
